<div class="main-info-block" *transloco="let t">
  <div class="metrics" [ngClass]="{'only-one-row': showOnlyDistAndTime()}">
    <div class="item">
          <span class="flex-align-center">
            <q-svg-wrapper class="icon" [width]="20" [height]="20" viewBox="0 0 24 24" iconPath="project-icons/clock"
                        style="color: #718096"></q-svg-wrapper>
            <span class="smaller-label"> {{ t('time') }}</span>
          </span>
      <span style="overflow: hidden">
            <span class="value-label">{{ timeToPrettyString(msToTimeSpan(metrics().time)) }}</span>
          </span>
    </div>

    @if (!showOnlyDistAndTime()) {
      <div class="item">
        <span class="flex-align-center">
            <q-svg-wrapper class="icon" [width]="20" [height]="20" viewBox="0 0 24 24" iconPath="project-icons/flame"
                        style="color: #FF3B30"></q-svg-wrapper>
            <span class="smaller-label"> {{ t('calories') }}</span>
          </span>
        <span>
            <span class="value-label">{{ metrics().calories ?? '-' }}</span>
          </span>
      </div>
    }

    <div class="item">
          <span class="flex-align-center">
            <q-svg-wrapper class="icon" [width]="20" [height]="20" viewBox="0 0 24 24"
                        iconPath="project-icons/distance-arrows"
                        style="color: #007AFF"></q-svg-wrapper>
            <span class="smaller-label"> {{ t('distance') }}</span>
          </span>
      <span>
            <span class="value-label">{{ distanceInMetersToPrettyString(metrics().distance) }}</span>
          </span>
    </div>

    @if (!showOnlyDistAndTime()) {
      <div class="item">
        <span class="flex-align-center">
            <q-svg-wrapper class="icon" [width]="20" [height]="20" viewBox="0 0 24 24" iconPath="project-icons/run"
                        style="color: #34C759"></q-svg-wrapper>
            <span class="smaller-label"> {{ t('steps') }}</span>
          </span>
        <span>
            <span class="value-label">{{ metrics().steps }}</span>
          </span>
      </div>
    }
  </div>
</div>
